import React, { useEffect } from 'react';
import DesktopHeader from './DesktopHeader';

export function isValidPathname(pathname) {
  return !pathname ? false : !pathname.includes('/register') && !pathname.includes('/login');
}

function DesktopHeaderVM() {
  const { pathname } = window.location;

  useEffect(() => {
    const geoLocationCoords = sessionStorage.getItem('x-exp-rvn-geo');
    const isUserDeniedLocation = sessionStorage.getItem('isUserDeniedLocation');
    if (!isUserDeniedLocation && !geoLocationCoords && navigator?.geolocation) {
      navigator.geolocation.getCurrentPosition((location) => {
        if (location) {
          sessionStorage.setItem('isUserDeniedLocation', 0);
          const { latitude, longitude } = location.coords;
          const coordsVal = `lat=${latitude},long=${longitude}`;
          sessionStorage.setItem('x-exp-rvn-geo', coordsVal);
        }
      },
      (error) => {
        // handle location error
        if (error.code === error.PERMISSION_DENIED) {
          sessionStorage.setItem('isUserDeniedLocation', 1);
        }
      }
      );
    }
  }, []);

  const visibilityHeader = () => {
    if (pathname.includes('checkout') && !pathname.includes('order-confirmation')) {
      return false;
    }
    return true;
  };
  const storeLocatorHeader = !!window?.FLAGS?.StoreLocatorHeader && visibilityHeader();
  const isTenderTypePromosEnabled = !!window?.FLAGS?.TenderTypePromos;

  return (
    <DesktopHeader
      storeLocatorHeader={storeLocatorHeader}
      isTenderTypePromosEnabled={isTenderTypePromosEnabled}
    />
  );
}

export default DesktopHeaderVM;
